import { ACTIVITY_PING_INTERVAL_MS } from 'core/constants';

import API from 'utils/api';
import Logger from 'utils/logger';

const LISTENER_OPTIONS = { capture: true, passive: true };
const EVENTS = ['keydown', 'pointerdown'] as const;

let listening = false;
let lastPingAt = 0;

function onActivity(): void {
  const now = Date.now();
  if (now - lastPingAt < ACTIVITY_PING_INTERVAL_MS) return;
  lastPingAt = now;
  API.user
    .getTimezone()()
    .catch((e) => Logger.info('Activity keep-alive failed', e));
}

export function startActivityListener(): void {
  if (listening) return;
  listening = true;
  EVENTS.forEach((event) => document.addEventListener(event, onActivity, LISTENER_OPTIONS));
}

export function stopActivityListener(): void {
  if (!listening) return;
  listening = false;
  lastPingAt = 0;
  EVENTS.forEach((event) => document.removeEventListener(event, onActivity, LISTENER_OPTIONS));
}
